import { CSSObject } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getTicketColumnIdStyles = (theme: Theme): CSSObject => ({
    width: theme.spacing(20),
});
